import React,{useEffect, useRef} from 'react'
import ErpLayout from '../../../../../layout/components/ErpLayout'
import { useState } from 'react'
import CustomerForm from '../components/CustomerForm';

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { useAppData } from '../../../../../context/AppDataContext';
import ConfirmDialog from '../../../../../components/ConfirmDialog';
import { Print } from '@mui/icons-material';
import { Link } from 'react-router-dom';



const CellActions = (props) =>{
    return(
        <>
            <Link to={`/customer/details/${props.data.id}`}>{props.data.customerName}</Link>
            {/*
              <CustomerForm  callBack={props.callBack} data={props.data} />
              <ConfirmDialog id={props.data.id} confirm={ ()=>props.remove(props.data.id)} >Are you Sure You want to remove</ConfirmDialog>
            */}
        </>
    )
  }


function CustomerDashboardPage() {

  const {getMasterLabel} = useAppData()
  const {customerList,getCustomerList} = useAppData();
  const gridRef = useRef();
  

  const remove = () =>{

  }

  const [defaultColDef] = useState({
    floatingFilter: true,
    filterParams: {
      buttons: ['apply'],
    },
    resizable: true,
    width:120,
    filter:true,
    sortable: true,
    cellStyle: { 'textTransform': 'uppercase' },
  });


  const [columnDefs,setColumnDef] = useState();
    const prepairColumnDef = () => {
    let _columnDefs = [
        {field:"id",headerName: "ID"},
        
        {headerName:"Customer Name", width:"200", valueGetter: params => params.data.title,
            cellRenderer: CellActions,
            cellRendererParams: {
                callBack:getCustomerList,
                remove:remove
            },
        }, 
        {field:"customerOrg",headerName: "Customer Org",width:250},
        {field:"gst",headerName: "Customer GST#",width:250},
        {field:"phone",headerName: "Phone"},
        {field:"email",headerName: "Email"},
             
    ];
    setColumnDef(_columnDefs);
  }

  const onBtnExport = () => {
    gridRef.current.api.exportDataAsCsv("data.csv");
  };

  useEffect(()=>{    
    prepairColumnDef();
  },[]);
  return (
    <ErpLayout>
      <div className='row'>
        <div className='col-md-6'><h4>Customers</h4></div>
        <div className='col-md-6'> 
          <span className='float-end'><CustomerForm callBack={getCustomerList} /></span>
          <button className='btn btn-warning me-2 float-end' onClick={onBtnExport} ><Print /> Export </button>
        </div>
        <div className='col-md-12 mt-2'>
          <div className="ag-theme-alpine" style={{height: 400}}>
              <AgGridReact
                ref={gridRef}
                rowData={customerList}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                animateRows={true}
                onGridReady={getCustomerList}
              />
            </div>
          </div>
        </div>
    </ErpLayout>
    
  )
}

export default CustomerDashboardPage